
// @ts-nocheck
import React from 'react';
import { AntSchema } from '@9troisquarts/ant-form';
import { sectors, typeOfContracts } from '../../../../../utils/itemList';
import {Alert, Col, Tooltip} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

export const offerInformationsSchema: AntSchema = (intl) => [
  {
    name: 'typeOfContract',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.type_of_contract' }),
    required: true,
    input: {
      type: 'select',
      options: typeOfContracts.map((contract) => ({
        label: intl.formatMessage({ id: `type_of_contracts.${contract}` }),
        value: contract,
      })),
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'companyName',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.company_name' }),
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'title',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.offer_title' }),
    required: true,
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'location',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.location' }),
    input: {
      type: 'places',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'sector',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.sector' }),
    required: true,
    input: {
      type: 'select',
      required: true,
      options: sectors.map((sector) => ({
        label: intl.formatMessage({ id: `sectors.${sector}` }),
        value: sector,
      })),
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'minDurationMonths',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.min_duration_months' }),
    input: {
      type: 'number',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
];

export const contactInformationsSchema: AntSchema = (intl, admin = true) => [
  {
    name: 'contactFirstName',
    label: intl.formatMessage({ id: 'words.first_name' }),
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'contactLastName',
    label: intl.formatMessage({ id: 'words.last_name' }),
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  <Col xs={24}>
    <Alert
      style={{ marginBottom: 10 }}
      key="alert"
      message={intl.formatMessage({ id: 'sentences.contact_informations_required'})}
      type="warning"
    />
  </Col>,
  {
    name: 'contactEmail',
    required: true,
    label: intl.formatMessage({ id: 'words.email' }),
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'contactPhone',
    required: true,
    label: intl.formatMessage({ id: 'words.phone' }),
    input: {
      type: 'string',
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'applicationUrl',
    required: true,
    label: intl.formatMessage({ id: 'words.application_url' }),
    input: {
      type: 'string'
    },
    colProps: {
      xs: 24
    }
  },
  admin && {
    name: 'shared',
    input: {
      type: 'checkbox',
      text: intl.formatMessage({ id: 'sentences.share_informations' }),
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
];

export const offerDetailsSchema: AntSchema = (intl) => [
  {
    name: 'companyDetails',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.company_details' }),
    input: {
      type: 'markdown',
      inputProps: {
        displayOptions: ["Bold", "Italic", "bullet", "number", "createLink"]
      },
    },
    style: {
      marginTop: "18px",
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'missionDetails',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.mission_details' }),
    input: {
      type: 'markdown',
      inputProps: {
        displayOptions: ["Bold", "Italic", "bullet", "number", "createLink"]
      },
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
  {
    name: 'profileDetails',
    label: intl.formatMessage({ id: 'activerecord.attributes.offer.profile_details' }),
    input: {
      type: 'markdown',
      inputProps: {
        displayOptions: ["Bold", "Italic", "bullet", "number", "createLink"]
      },
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  }
]

export const keywordsSchema: AntSchema = (intl) => [
    {
    name: 'keywords',
    label:
    <span>
      {intl.formatMessage({ id: 'activerecord.attributes.offer.keywords' })}
      <Tooltip title= 'Séparez vos mots clés par une virgule'>
        &nbsp; {<FontAwesomeIcon icon={solid('circle-question')} />}
      </Tooltip>
    </span>,
    input: {
      type: 'string',
      inputProps: {
        placeholder: 'Renseignez des mots clés (société, compétences ....)'
      },
    },
    colProps: {
      xs: 24,
      md: 24,
    },
  },
]


